module.exports = __webpack_public_path__ + "img/logo-wot.e6ffd69a.png";